module.exports = __webpack_public_path__ + "mobile/img/tu3.ac21fbbc.png";